export default __webpack_public_path__ + "602d6078012d1735b662116603f66b36.png";